import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RootState } from "../../redux/rootReducers";

const RouteAuth = (props: any) => {
  const location = useLocation();
  const authRole = useSelector((state: RootState) => state.authReducer)?.role;
  const isStepOneComplete = useSelector(
    (state: RootState) => state.authReducer
  )?.isStepOneComplete;

  const otpMessage = useSelector(
    (state: RootState) => state.otpReducer
  ).otpMessage;
  const { pathname } = location;
  var isValidRoute;
  if (pathname === "/login") {
    isValidRoute = isStepOneComplete;
  } else if (pathname === "/otp") {
    isValidRoute =
      props?.availableRoles.includes(authRole) || isStepOneComplete;
  } else {
    isValidRoute =
      props?.availableRoles.includes(authRole) && otpMessage === "success";
  }

  return isValidRoute ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
export default RouteAuth;
